import { render, staticRenderFns } from "./tietosuojaseloste-modal.vue?vue&type=template&id=93b382ba&scoped=true&"
import script from "./tietosuojaseloste-modal.vue?vue&type=script&lang=ts&"
export * from "./tietosuojaseloste-modal.vue?vue&type=script&lang=ts&"
import style0 from "./tietosuojaseloste-modal.vue?vue&type=style&index=0&id=93b382ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b382ba",
  null
  
)

export default component.exports